module.exports = __webpack_public_path__ + "static/img/banner-3.7e84c780.png";